import type { CityConfig } from "../city-template/types";

export const hamptonConfig: CityConfig = {
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from New Hampshire Division of Vital Records Administration. Online, mail, or in-person options available for Hampton and Rockingham County residents.", url: "https://www.sos.nh.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through New Hampshire Division of Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.sos.nh.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Rockingham County Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.courts.state.nh.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Rockingham County Superior Court. Required for name change passport corrections.", url: "https://www.courts.state.nh.us/" },
  ],
  city: "Hampton",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "hampton",
  route: "/cities/hampton",
  title: "Emergency Passport Hampton, NH | Fast Expedited Passport Renewal & Same-Day",
  metaDescription: "Emergency passport and expedited passport services in Hampton, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Seacoast New Hampshire. A+ BBB rated, registered State Dept. courier. Serving Exeter, Portsmouth, Seabrook.",
  h1: "Emergency & Expedited Passport Services in Hampton, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hampton and Seacoast New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hampton%20Beach%20New%20Hampshire%20scenic%20view%20with%20sandy%20Atlantic%20coastline%20and%20beachfront%20boardwalk%2C%20historic%20Hampton%20Beach%20Casino%20Ballroom%2C%20summer%20vacation%20atmosphere%20with%20warm%20golden%20light%2C%20calm%20ocean%20waves%20and%20blue%20sky%2C%20New%20England%20seacoast%20townscape%2C%20professional%20landscape%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20soft%20earth%20tones%20and%20warm%20amber%20sky%2C%20photorealistic%20coastal%20scenery&width=1800&height=700&seq=hampton-nh-hero-001&orientation=landscape",
  heroImageAlt: "Hampton Beach New Hampshire scenic Atlantic coastline with sandy beach and historic boardwalk",
  geoPosition: "42.9376;-70.8389",
  geoPlacename: "Hampton, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55–70 minutes from Hampton via I-95",
  },
  nearbyCitiesZips: [
    { name: "Hampton", zips: "03842, 03843" },
    { name: "Exeter", zips: "03833" },
    { name: "Seabrook", zips: "03874" },
    { name: "North Hampton", zips: "03862" },
    { name: "Rye", zips: "03870" },
    { name: "Portsmouth", zips: "03801–03804" },
    { name: "Dover", zips: "03820–03822" },
    { name: "Stratham", zips: "03885" },
    { name: "Newmarket", zips: "03857" },
    { name: "Epping", zips: "03042" },
    { name: "Raymond", zips: "03077" },
    { name: "Kingston", zips: "03848" },
    { name: "Danville", zips: "03819" },
    { name: "East Kingston", zips: "03827" },
    { name: "Hampstead", zips: "03841" },
    { name: "Sandown", zips: "03873" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Seacoast New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Dover", route: "/cities/dover" },
    { name: "Exeter", route: "#" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Manchester", route: "/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Keene", route: "/cities/keene" },
  ],
  fpcOfficeAddress: "One Boston Place, Suite 2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Hampton remotely via secure courier. We do not have a walk-in office in Hampton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Seacoast New Hampshire travelers.",
  fpcOfficeDistance: "Serving all of Rockingham and Strafford Counties",
  serviceAreaIntro: "From Hampton Beach to the neighborhoods along Lafayette Road, from the Seabrook border to the North Hampton line — Fast Passport Center serves the entire Hampton community. We regularly help travelers from Exeter, Seabrook, Portsmouth, and Dover get their passports fast.",
  nearbyCitiesIntro: "We serve all Hampton neighborhoods and nearby Seacoast New Hampshire cities including Exeter, Seabrook, North Hampton, Rye, Portsmouth, Dover, Stratham, Newmarket, Epping, Raymond, and Kingston. If you are in the Seacoast region, we have you covered.",
  howItWorksIntro: "Most Hampton travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Portsmouth International Airport (PSM) just 20 minutes away and Boston Logan an hour south, Hampton travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Hampton and Seacoast New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hampton? Here are the most common ones we hear from Seacoast New Hampshire travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hampton international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hampton", description: "Urgent passport processing for Hampton travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal Hampton", description: "Fast passport renewal for Hampton residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport Application Hampton", description: "First-time passport application assistance for Hampton residents with step-by-step acceptance clerk guidance." },
    { name: "Lost or Stolen Passport Replacement Hampton", description: "Passport replacement service for Hampton residents with lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport Service Hampton", description: "Passport services for Hampton families with minors under 16, including parental consent documentation." },
    { name: "Passport Name Change Hampton", description: "Passport name change service for Hampton residents after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sandra M.",
      location: "Hampton, NH",
      rating: 5,
      text: "Family cruise to the Bahamas was in 5 days and my son's passport was expired. Fast Passport Center got us a new one in 36 hours. Saved our vacation from Hampton Beach.",
      service: "Emergency Passport",
    },
    {
      name: "Gregory T.",
      location: "Hampton, NH",
      rating: 5,
      text: "Needed to renew for a business trip to Dublin. The process was smooth, they reviewed my documents, and I had my passport in 5 days. Hampton residents — this is the service to trust.",
      service: "Passport Renewal",
    },
    {
      name: "Rebecca L.",
      location: "Exeter, NH",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Spain. They walked me through the DS-64 process and got me a replacement in 2 days. Fast service for Exeter.",
      service: "Lost Passport",
    },
    {
      name: "Thomas W.",
      location: "Seabrook, NH",
      rating: 5,
      text: "As a frequent international traveler from Seabrook, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable for the Seacoast.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "hampton-1",
      name: "Hampton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 Lafayette Rd",
      city: "Hampton",
      state: "NH",
      zip: "03842",
      phone: "(603) 926-8701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.4 miles from downtown Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Hampton. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-2",
      name: "Exeter Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Front St",
      city: "Exeter",
      state: "NH",
      zip: "03833",
      phone: "(603) 772-0501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5.2 miles from Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hampton and Exeter residents. Popular facility — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-3",
      name: "Seabrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "90 Main St",
      city: "Seabrook",
      state: "NH",
      zip: "03874",
      phone: "(603) 474-2421",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "3.8 miles from Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Seabrook and Hampton Beach residents. Limited hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-4",
      name: "Portsmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Campus Dr",
      city: "Portsmouth",
      state: "NH",
      zip: "03801",
      phone: "(603) 431-6241",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12.4 miles from Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service acceptance facility. Photo and shipping available. Major facility for Seacoast New Hampshire.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-5",
      name: "Dover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "56 Broadway",
      city: "Dover",
      state: "NH",
      zip: "03820",
      phone: "(603) 742-4471",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18.5 miles from Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Strafford County. Popular for Seacoast residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hampton-6",
      name: "Stratham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "76 Portsmouth Ave",
      city: "Stratham",
      state: "NH",
      zip: "03885",
      phone: "(603) 772-4211",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "7.2 miles from Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Stratham and North Hampton residents. Limited hours — book ahead.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hampton photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Seacoast New Hampshire acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hampton applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampton families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hampton travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hampton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hampton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hampton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hampton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Seacoast New Hampshire travelers." },
    { q: "How fast can I renew my passport in Hampton?", a: "Fast Passport Center offers fast passport renewal in Hampton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Hampton in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Hampton?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hampton residents." },
    { q: "Can I expedite a child passport in Hampton?", a: "Yes. Fast Passport Center expedites child passports in Hampton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hampton with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Hampton?", a: "With Fast Passport Center's emergency courier service, Hampton travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Hampton?", a: "Popular options include the Hampton Post Office (03842), Exeter Post Office (03833), Seabrook Post Office (03874), and Portsmouth Post Office (03801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Hampton?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Exeter or Seabrook?", a: "We serve all of Seacoast New Hampshire including Exeter, Seabrook, North Hampton, Rye, Portsmouth, Dover, Stratham, Newmarket, and Kingston. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Hampton?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hampton", address: "103 Lafayette Rd, Hampton, NH 03842", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "Walgreens — Hampton", address: "105 Lafayette Rd, Hampton, NH 03842", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/store-locator" },
    { name: "FedEx Office — Exeter", address: "140 Epping Rd, Exeter, NH 03833", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/" },
    { name: "UPS Store — Exeter", address: "105 Portsmouth Ave, Exeter, NH 03833", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "Walmart — Seabrook", address: "700 Lafayette Rd, Seabrook, NH 03874", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Rite Aid — Hampton", address: "105 Lafayette Rd, Hampton, NH 03842", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations" },
    { name: "Costco — Portsmouth", address: "100 Gosling Rd, Portsmouth, NH 03801", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/warehouse-locations" },
  ],
  dmvLocations: [
    { name: "DMV — Hampton", address: "1 Merrill Industrial Dr, Hampton, NH 03842", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Portsmouth", address: "40 Pleasant St, Portsmouth, NH 03801", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Exeter", address: "10 Ladd St, Exeter, NH 03833", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Dover", address: "50 Boston Harbor Rd, Dover, NH 03820", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for Seacoast New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "PSM", name: "Portsmouth International Airport", distance: "15 miles from Hampton", address: "36 New Hampshire Ave, Portsmouth, NH 03801", note: "Regional airport with some international flights. Convenient for Hampton and Seacoast New Hampshire travelers.", flightUrl: "https://www.flyportsmouth.com/", flightLabel: "Portsmouth Airport", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "45 miles from Hampton", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-95.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "45 miles from Hampton", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major domestic airport for Hampton travelers. International flights to Canada and Europe.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
  ],
};